/* istanbul ignore file */
// Static, env-independent error page for bootstrap failures (e.g. broken
// /config.json). Renders without React / Apollo / Keycloak so the page is
// visible even when the runtime-config fetch is what failed.
//
// Shared between Vite entrypoints in apps/frontend (app/index.tsx and
// project-contractee-input/index.tsx). The wizard maintains its own copy
// in apps/frontend-wizard/src/wizard/bootstrap-error.ts; cross-app dedup
// would require a new shared lib for ~30 lines and was deferred.

export function renderBootstrapError(
  error: unknown,
  options: { title?: string } = {}
): void {
  const title = options.title ?? "App could not start";
  const message =
    error instanceof Error ? error.message : "Unknown bootstrap error";
  document.body.innerHTML = `
    <div style="
      font-family: system-ui, -apple-system, sans-serif;
      max-width: 480px;
      margin: 80px auto;
      padding: 32px;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      color: #333;
    ">
      <h1 style="margin: 0 0 16px; font-size: 20px;">${escapeHtml(title)}</h1>
      <p style="margin: 0 0 12px;">
        The application configuration could not be loaded. This is usually a
        deployment issue and resolves on its own — please retry in a few
        minutes.
      </p>
      <p style="margin: 0; font-size: 12px; color: #888;">
        Reason: ${escapeHtml(message)}
      </p>
    </div>
  `;
}

function escapeHtml(value: string): string {
  return value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}
